import {useApi} from "../Api";
import {
    ExcessGroupProductCodeLocationGroupEntityRequest,
    ExcessGroupProductCodeLocationGroupEntityResponse
} from "../types/excessGroupProductCodeLocationGroup";

export const useExcessGroupProductCodeLocationGroupRepository = () => {
    const {GET, POST} = useApi();

    const PATH = "/pricing/excess-product-code-location-group";

    function getAssociations(excessGroupId: number): Promise<ExcessGroupProductCodeLocationGroupEntityResponse[]> {
        return GET(`${PATH}/by-excess-group?excessGroupId=${excessGroupId}`);
    }

    function postExcessGroupProductCodeLocationGroupAll(excessGroupProductCodeLocationGroupEntityRequest: ExcessGroupProductCodeLocationGroupEntityRequest): Promise<ExcessGroupProductCodeLocationGroupEntityRequest> {
        return POST(`${PATH}/new-association`, excessGroupProductCodeLocationGroupEntityRequest);
    }

    return {
        getAssociations,
        postExcessGroupProductCodeLocationGroupAll
    };
};